import { ObrasKanbanBoard } from "@/shared/components";
import type { ObrasCardsViewModel } from "./types-obras-cards";

/**
 * Visão Cards (RN04): uma coluna por status da obra, sem arrastar entre colunas; até 10 obras por coluna e "Mostrar mais
 * obras" (+10, pelo servidor) enquanto houver mais. O quadro é o `ObrasKanbanBoard` do shared, o mesmo do Financeiro.
 */
export function ObrasCardsView({ isLoading, device, boardColumns }: ObrasCardsViewModel) {
  return (
    <ObrasKanbanBoard
      testId="obras-cards"
      device={device}
      isLoading={isLoading}
      columns={boardColumns}
    />
  );
}
